import { useAuth } from '../../lib/auth';
import BillsView from '../../components/BillsView';

export default function Bills() {
  const { user } = useAuth();
  return <BillsView role={user?.role || 'manager'} />;
}
